import { createConstants } from 'app/common/CommonUtils';

export default createConstants(`

  IS_2FA_REQUIRED
  IS_BAD_CODE
  IS_BAD_CREDENTIALS
  IS_DISABLED
  IS_INVALID_RESET
  IS_LOCKED
  IS_MISSING_CSRF
  IS_RESET
  IS_SENT
  IS_SINGLE_SESSION
  IS_UNAUTHENTICATED
  IS_VALID_CODE
  IS_VALID_LOGIN
  NOT_FOUND
  TRYING_TOO_OFTEN

`);
